import { createContext } from "react";

export interface FilterContextValue {
  filter: Record<string, any>;
  params: {
    page: number;
    rowsPerPage: number;
    [key: string]: any;
  };
  initialPeriod?: "day" | "month" | "week" | "year";
  onClearFilter: () => void;
  onChangeParam: (key: string, value: any) => void;
  onChangeParams: (items: Record<string, any>) => void;
  onChangeFilter: (key: string, value: any) => void;
  onPageChange: (event: any, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FilterContext = createContext<FilterContextValue | null>(null);
